import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import {  WfmAbsence  } from "../../../../services/actionsService"
import { manualRequestsService } from "../../../../services/myActionsService"
import { setSelectedDays } from "../../../../redux/reducers/timeOffRequestsReducer"
import { RootStore, useAppDispatch } from "../../../../redux/store"
import { AbsenceDayRequest } from "../../../../types/absence"

const defaultShift = '09:00-17:30 L'

const useShiftOnDay = (wfmAbsence?: WfmAbsence) => {
  const dispatch = useAppDispatch()

  const { selectedDays } = useSelector((state: RootStore) => state.timeOff)
  
  const [disableShiftStringEditing, setDisableShiftStringEditing] = useState<boolean>(false)
  const [shiftString, setShiftString] = useState<string>(defaultShift)

  useEffect(() => {
    setShiftString(wfmAbsence?.shiftString ?? defaultShift)
    setDisableShiftStringEditing(Boolean(wfmAbsence))
  }, [wfmAbsence])
  
  const calculatePartDayAbsenceForWfm = useCallback((
    wfmAbsenceInstance: WfmAbsence,
    hasHadLunch: boolean,
  ) => {
    manualRequestsService
      .getShiftAbsentHours(
        wfmAbsenceInstance.employeeId,
        wfmAbsenceInstance.scheduleStartDate,
        wfmAbsenceInstance.isPartDayAbsence,
        wfmAbsenceInstance.absenceStartDate,
        hasHadLunch,
        wfmAbsenceInstance.shiftString
      )
      .then(res => {
        if (res.shiftHours !== undefined && selectedDays && selectedDays.length === 1) {
          const day = {
            day: new Date(wfmAbsenceInstance.scheduleStartDate ?? selectedDays[0].day),
            checked: selectedDays[0].checked,
            hours: res.shiftHours,
          } as AbsenceDayRequest
          dispatch(setSelectedDays([day]))
        }
        if (res.formattedShiftString !== undefined) {
          setShiftString(res.formattedShiftString)
        }
      })
  }, [setShiftString, selectedDays, setSelectedDays, dispatch])

  return {
    shiftString,
    setShiftString,
    disableShiftStringEditing,
    setDisableShiftStringEditing,
    calculatePartDayAbsenceForWfm,
  }
}

export default useShiftOnDay